import { render, staticRenderFns } from "./Categorieslist.vue?vue&type=template&id=08488c15&scoped=true&"
import script from "./Categorieslist.vue?vue&type=script&lang=js&"
export * from "./Categorieslist.vue?vue&type=script&lang=js&"
import style0 from "./Categorieslist.vue?vue&type=style&index=0&id=08488c15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08488c15",
  null
  
)

export default component.exports